import Loader from '../components/newinterface/guestPortal/loader';
const SiteLoader = () => {
    return (
        <div className="site_loader">
            {/* <img src={s3BucketUrl_WebsiteImages+"SuiteAmerica-Animation.gif"}/> */}
            <Loader />
        </div>
    )
}
export default SiteLoader;